import styled from "@emotion/styled";
import { RequiredThemeKeys } from "../../../../util/theme";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { selectV2Theme } from "../selectV2Theme";

export interface OptionBaseStyledProps {
    themeMode: RequiredThemeKeys;
    height?: number;
    isVirtualized?: boolean;
}

const shouldForwardProp = (propName: string): boolean => {
    switch (propName) {
        case "height":
        case "isVirtualized":
        case "themeMode":
            // Just add any extra props here :)
            return false;
    }
    return true;
};

export const OptionBaseStyled = styled("div", {
    shouldForwardProp,
})<OptionBaseStyledProps>`
    box-sizing: border-box;
    border-radius: ${({ themeMode }) => menuTheme.borderRadius(themeMode)};
    cursor: pointer;
    height: auto;
    line-height: 18px;
    margin: ${({ isVirtualized }) => (isVirtualized ? "0" : "0 4px")};
    min-height: ${({ height }) => height}px;
    overflow: hidden;
    padding: ${({ themeMode }) => selectV2Theme.padding(themeMode)};
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;

    background-color: ${({ themeMode }) => menuTheme.backgroundColor.rest(themeMode)};
    color: ${({ themeMode }) => menuTheme.fontColor.rest(themeMode)};

    > * {
        font-size: ${({ themeMode }) => menuTheme.fontSize(themeMode)};
        white-space: normal;
        font-weight: 500;
    }

    &[aria-selected="true"] {
        // TODO the focus style here? Really?
        color: ${({ themeMode }) => menuTheme.fontColor.focus(themeMode)};
        background-color: ${({ themeMode }) => selectV2Theme.option.backgroundColor.hover(themeMode)};
    }

    &:not([aria-disabled="true"]):active {
        background-color: ${({ themeMode }) => selectV2Theme.option.backgroundColor.active(themeMode)};
    }

    &[aria-disabled="true"] {
        color: ${({ themeMode }) => menuTheme.fontColor.disabled(themeMode)};
        background-color: transparent;
        &:hover {
            cursor: not-allowed;
        }
    }
`;
